export const KEYWORD_CHAR_LIMIT = 255
